export default function PHP_is_file() {
  return (
    <div>
      <h1>PHP_is_file</h1>
    </div>
  );
}
